//Provider Service 중 Question에 나타나는 Sub들 전역 Vuex
import Vue from 'vue';
import axios from '@core_utils/api/_axios.js'
import { generateSubcomponentDataBy } from '@core_utils/subComponent/subComponent';
import commonLogout from '@core_utils/common-logout';

const questions = {
    namespaced: true,
    state: {
        subs: [],
        subs_loaded: false,
        answer_company: {},
        edit_mode: true,
    },
    getters: {
        getter_question_edit_mode (state) {
            return state.edit_mode
        },
        getter_question_answer_company (state) {
            return state.answer_company
        }
    },
    mutations: {
        update_subs(state, new_subs){
            state.subs = new_subs
        },
        add_sub(state, new_sub){
            state.subs.push(new_sub)
        },
        update_sub (state, new_sub) {
            let idx = state.subs.findIndex(item => (new_sub.sub_id && item.sub_id && new_sub.sub_id === item.sub_id) || (!item.sub_id && item.sub_init_id == new_sub.sub_init_id))
            if (idx > -1) {
                Vue.set(state.subs, idx, Object.assign({}, state.subs[idx], new_sub))
            }
        },
        update_subs_loaded(state, new_status){
            state.subs_loaded = new_status
        },
        update_answer_company(state, new_company){
            state.answer_company = new_company
        },
        change_edit_mode(state, mode){
            state.edit_mode = mode
        },
        reset_subs(state){
            state.subs = [],
            state.subs_loaded = false
        }
    },
    actions: {
        async readSubs ({ commit }, question) {
            try {
                let temp_result = []
                commit('update_subs', [])
                commit('update_subs_loaded', false)

                if (question.contents && question.contents.length) {
                    const _question_contents = Array.isArray(question.contents)
                        ? question.contents.join(',')
                        : !question.contents
                            ? ''
                            : typeof question.contents === "string"
                                ? JSON.parse(question.contents).join(',')
                                : question.content.join(',')

                    const _res_subs_init = await axios.get('/subs', {
                        params: {
                            company_id: question.company_id,
                            company_name: question.company_name,
                            campaign_id: question.campaign_id,
                            sub_codes: _question_contents
                        }
                    })

                    if (_res_subs_init.data.length) {
                        temp_result = _question_contents.split(',').reduce((_reordered_subs, _sub_code) => {
                            let subs = _res_subs_init.data.find(({ sub_code }) => sub_code === _sub_code)
                            if (subs) _reordered_subs.push(generateSubcomponentDataBy(subs, question.question_code))
                            return _reordered_subs
                        }, [])
                    }
                }

                commit('update_subs', temp_result)
                commit('update_subs_loaded', true)
            } catch (error) {
                console.log(error);
                if (error.response) {
                    if (error.response.status === 401) {
                        const is_alert_duplicate_login = localStorage.getItem('is_alert_duplicate_login')
                        await commonLogout(is_alert_duplicate_login)
                    }
                }
            }
        },
        // 1.Auditor 용 subs_adjust 읽어오기
            // subs_adjust는 기존 sub의 복제본으로 가져옴 (read_sub 대신하는 역할)
            // subs 통 복사가 아니라, foriegn_key(campaign_id, sub_code, company_name) + sub_data_contents, + author_name, author_comment, time_stamp 저장
        
        // 2. SubComponentMixin.js에서 initiateData 말고 audit_mode 일 때 initiate할 함수 하나 더 불러서 그려주기

        // 3. 각 subcomponent에서 값을 수정/편집한 다음 저장 
            // 기존 save_sub과 다르게 DB의 subs_adjust 테이블로 저장해야 함
            // v-model을 분리해서, audit_mode일때 save_sub_adjust 로 저장하도록 조정
            // 기존과 다르게 저장하려면 sub_data_conents를 다르게 받아야 함        
    }
}

export default questions
